export const DeletedItems = {
  userHasSufficientPrivilege: (p) => p.editItems,
  planIncludesReport: () => true,
};
